export enum CustomizedBookingFieldType {
  TEXT = 'TEXT',
  NUMBER = 'NUMBER',
  DATE = 'DATE',
  BOOLEAN = 'BOOLEAN',
  MULTILINE = 'MULTILINE'
}
